import React from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import MapHotspotsComponent from "../hotspots/Hotspots";

const MapHotspotsPage = () => {
  return (
    <Box h="100dvh" display="flex" flexDirection="column">
      <Navbar />
      <Box flex="1" zIndex={1}>
        <MapHotspotsComponent />
      </Box>
    </Box>
  );
};

export default MapHotspotsPage;